import { render, staticRenderFns } from "./InlineMessageBox.vue?vue&type=template&id=08e97c2e&scoped=true&"
import script from "./InlineMessageBox.vue?vue&type=script&lang=js&"
export * from "./InlineMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./InlineMessageBox.vue?vue&type=style&index=0&id=08e97c2e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../buyers/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e97c2e",
  null
  
)

export default component.exports